const actionTypeIdentifier = 'F910B160-11D0-4C88-8D6E-adfgd2343'; // to be updated


export const setCountryOptions = `SET-NEW-CIRCUIT-COUNTRY-OPTIONS-${actionTypeIdentifier}`;
export const setAddressOptions = `SET-NEW-CIRCUIT-ADDRESS-OPTIONS-${actionTypeIdentifier}`;
export const setAddress1Options = `SET-NEW-CIRCUIT-ADDRESS1-OPTIONS-${actionTypeIdentifier}`;
export const setAddress2Options = `SET-NEW-CIRCUIT-ADDRESS2-OPTIONS-${actionTypeIdentifier}`;
export const setCountryLoading = `SET-COUNTRY-LOADING-${actionTypeIdentifier}`;
export const setAddressLoading = `SET-ADDRESS-LOADING-${actionTypeIdentifier}`;
export const setAddress1Loading = `SET-ADDRESS-LOADING-${actionTypeIdentifier}`;
export const setAddress2Loading = `SET-ADDRESS-LOADING-${actionTypeIdentifier}`;

export const setCategoryOptions = `SET-NEW-CIRCUIT-CATEGORY-OPTIONS-${actionTypeIdentifier}`;
export const setCircuitTypeOptions = `SET-NEW-CIRCUIT-CIRCUIT-TYPE-OPTIONS-${actionTypeIdentifier}`;
export const setSubCircuitTypeOptions = `SET-NEW-CIRCUIT-SUB-CIRCUIT-TYPE-OPTIONS-${actionTypeIdentifier}`;
export const setPrimarySecondaryOptions = `SET-NEW-CIRCUIT-PRIMARY-SECONDARY-OPTIONS-${actionTypeIdentifier}`;
export const setDefaultPrimarySecondary = `SET-NEW-CIRCUIT-DEFAULT-PRIMARY-SECONDARY-${actionTypeIdentifier}`;
export const setPurposeOfUseOptions = `SET-NEW-CIRCUIT-PURPOSE-OF-USE-${actionTypeIdentifier}`;
export const setVendorOptions = `SET-NEW-CIRCUIT-FORM-VENDOR-OPTIONS-${actionTypeIdentifier}`;
export const setVendorDetails = `SET-NEW-CIRCUIT-FORM-VENDOR-DETAILS-${actionTypeIdentifier}`;

export const setFormSubmitted = `SET-NEW-CIRCUIT-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const setNewApproverDetails = `SET-NEW-APPROVER-DETAILS-${actionTypeIdentifier}`;
export const setFirstLoad = `SET-FIRST-LOAD-${actionTypeIdentifier}`;
export const wirelineLocationModelA = {
    countryCode: ''
    , country: ''
    , billingAddress: ''
    , billingAddressId: null
    , locationAddressId: ''
    , locationAddressPTPId: ''
    , isServiceLocation: true
    , isServiceLocationPTP: true
    , demarcLocation: ''
    , demarcLocationPTP: ''
    , locationAddress:''
    , locationAddressP2P: ''
}

export const wirelineSubscriptionModelA = {
    vendorDetailId: ''
    , itemUseId: 0
    , circuitTypeId: 0
    , subCircuitTypeId: 0
    , primarySecondaryId: 0
    , btnId: 0
    , mrc: "0.00"
    , nrc: "0.00"
    , mrc2: "0.00"
    , nrc2: "0.00"
    , totalCost: 0
}

export const wirelineBusinessModelA = {
    wireLineApproverId: 0
    , wireLineGlCodeId: 0
    , wireLineCostCenterId: 0
    , purposeOfUseId: 0
    , businessJustification: ''
    , additionalInformation: ''
    , localContactEmail: ''
    , localContactFullName: ''
    , localContactPhone: ''
    , altLocalContactEmail: ''
    , altLocalContactFullName: ''
    , altLocalContactPhone: ''
    , companyCode: ''
    , needByDate: ''
    , expediteRequest: false
}